import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],
})
export class TopNavComponent implements OnInit {
  @Input() logoUrl;
  url;
  toogle = false;
  fragments = [
    { label: 'Active Ingredients', url: 'active-ingredient' },
    { label: 'Forms and concentrations', url: 'forms' },
    { label: 'Indication uses and doses', url: 'indecation' },
    { label: 'Drug Interaction', url: 'interaction' },
    { label: 'Most Important Trials', url: 'trials' },
    { label: 'Guidelines', url: 'guidelines' },
  ];
  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((res) => {
      this.url = res.name;
    });
  }
  toogleFunction() {
    console.log(this.toogle);

    if (!this.toogle) {
      console.log('here');

      document.getElementById('tog').style.display = 'block';
      setTimeout(() => {
        document.getElementById('nav').style.clipPath = 'circle(75%)';
        this.toogle = true;
      }, 0.5);
    } else {
      document.getElementById('nav').style.clipPath = 'circle(0% at 95% -90px)';
      this.toogle = false;
      setTimeout(() => {
        document.getElementById('tog').style.display = 'none';
      }, 600);
    }
  }

  toogleUIFunction() {
    document.getElementById('nav').style.clipPath = 'circle(0% at 95% -90px)';
    this.toogle = false;
    setTimeout(() => {
      document.getElementById('tog').style.display = 'none';
    }, 600);
  }
}
